import { LineChart } from "@mantine/charts";
import { Paper, Text } from "@mantine/core";
import { OcularMotilityData, TestType } from "types/testTypes";
import { useTranslation } from "react-i18next";

export default function OcularMotilityErrorCharts(props: {
  testType: TestType;
  data: OcularMotilityData[];
}) {
  const testType: TestType = props.testType || TestType.CircularPursuit;
  const data: OcularMotilityData[] = props.data;

  const { t } = useTranslation();

  const formatTimestamp = (value) => {
    // Handle different types of values
    if (typeof value === "number") {
      return value.toFixed(2);
    } else if (typeof value === "string") {
      // Try to convert string to number if possible
      const num = parseFloat(value);
      return isNaN(num) ? value : num.toFixed(2);
    } else {
      // Fallback for null/undefined/other types
      return value?.toString() || "";
    }
  };

  return (
    <Paper withBorder p="md">
      <Text fw={600} c={"gray.6"}>
        {t("Error")}
      </Text>
      <LineChart
        my={"md"}
        h={200}
        data={data}
        withDots={false}
        withLegend
        dataKey="timestamp"
        series={[
          { name: "leftEyeError", color: "indigo.6", label: t("leftEye") },
          { name: "rightEyeError", color: "teal.6", label: t("rightEye") },
        ]}
        lineChartProps={{ syncId: "errors" }}
        legendProps={{ verticalAlign: "bottom", height: 50 }}
        xAxisProps={{ tickFormatter: formatTimestamp }}
      />

      {testType === TestType.CircularPursuit && (
        <>
          <Text fw={600} c={"gray.6"}>
            {t("TangentialVelocity")}
          </Text>
          <LineChart
            my={"md"}
            h={200}
            withLegend
            data={data}
            withDots={false}
            dataKey="timestamp"
            lineChartProps={{ syncId: "errors" }}
            series={[
              { name: "leftEyeTangentialVelocity", color: "indigo.6", label: t("leftEye") },
              { name: "rightEyeTangentialVelocity", color: "teal.6", label: t("rightEye") },
            ]}
            legendProps={{ verticalAlign: "bottom", height: 50 }}
            xAxisProps={{ tickFormatter: formatTimestamp }}
          />
        </>
      )}
    </Paper>
  );
}
